import React, { useCallback } from "react";
import PropTypes from "prop-types";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { Autocomplete } from "@totalsoft/rocket-webapp-components-deprecated";
import { emptyArray, emptyString } from "constants/defaultValues";

function AssetSupplierContent({ dialogState, setDialogState }) {
  const { t } = useTranslation();

  const handleSupplierChange = useCallback(
    (value) => {
      setDialogState((prev) => ({
        ...prev,
        supplierId: value,
        supplierName: dialogState.suppliers.find((x) => x.id === value)?.name,
      }));
    },
    [setDialogState, dialogState]
  );

  return (
    <Grid container direction="row" spacing={2}>
      <Grid item xs>
        <Autocomplete
          key={"asset_supplier"}
          label={t("Asset.Supplier")}
          simpleValue
          value={dialogState.supplierId || emptyString}
          options={dialogState.suppliers || emptyArray}
          onChange={handleSupplierChange}
          noOptionsText={t("General.AutocompleteNoOptions")}
        />
      </Grid>
    </Grid>
  );
}

AssetSupplierContent.propTypes = {
  dialogState: PropTypes.object.isRequired,
  setDialogState: PropTypes.func.isRequired,
};

export default AssetSupplierContent;
